import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Calendar, MapPin } from "lucide-react";

export default function EventsWidget() {
  const [events, setEvents] = useState([]);
  useEffect(() => {
    api.get("/events").then((r) => {
      const now = new Date().toISOString().slice(0, 10);
      setEvents((r.data || []).filter(e => (e.event_date || "").slice(0,10) >= now).slice(0, 5));
    }).catch(() => {});
  }, []);
  if (events.length === 0) return null;

  return (
    <section className="mb-12 bg-white border border-slate-200 rounded-xl p-6 shadow-sm" data-testid="events-widget">
      <div className="flex items-center gap-2 mb-4 pb-3 border-b-2 border-[#0F172A]">
        <Calendar className="w-5 h-5 text-[#DC2626]"/>
        <h2 className="font-devnagri-heading text-xl font-bold text-[#0F172A]">आगामी आयोजन · Local Events</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {events.map((e) => {
          const d = new Date(e.event_date);
          return (
            <div key={e.id} className="border border-slate-200 rounded-lg p-4 hover:shadow-md transition" data-testid={`event-${e.id}`}>
              <div className="flex items-start gap-3">
                <div className="bg-[#DC2626] text-white rounded-md p-2 text-center shrink-0 w-14">
                  <div className="text-[10px] uppercase tracking-widest font-admin">{d.toLocaleDateString("hi-IN", { month: "short" })}</div>
                  <div className="text-xl font-black leading-none mt-0.5">{d.getDate()}</div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="tag-cat text-[9px] mb-0.5">{e.category}</div>
                  <div className="font-devnagri-heading font-bold text-[#0F172A] leading-snug line-clamp-2">{e.title}</div>
                  {e.venue && <div className="text-xs text-slate-500 mt-1 flex items-center gap-1"><MapPin className="w-3 h-3"/>{e.venue}</div>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
